module.exports = __webpack_public_path__ + "static/media/_MIC2723.thumbnail.10eb4a88.png";